import React from 'react';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

function buildClassNames(transitionName) {
  if (!transitionName) return undefined;
  if (typeof transitionName === 'object') return transitionName;
  return {
    appear: `${transitionName}-appear`,
    appearActive: `${transitionName}-appear-active`,
    enter: `${transitionName}-enter`,
    enterActive: `${transitionName}-enter-active`,
    exit: `${transitionName}-leave`,
    exitActive: `${transitionName}-leave-active`,
  };
}

function buildTimeout(appearT, enterT, leaveT) {
  return {
    appear: appearT != null ? appearT : enterT != null ? enterT : 0,
    enter: enterT != null ? enterT : 0,
    exit: leaveT != null ? leaveT : 0,
  };
}

const CSSTransitionGroup = React.forwardRef(function CSSTransitionGroupCompat(
  props,
  ref
) {
  const {
    children,
    transitionName,
    transitionAppear = false,
    transitionEnter = true,
    transitionLeave = true,
    transitionAppearTimeout,
    transitionEnterTimeout,
    transitionLeaveTimeout,
    component = 'div',
    ...rest
  } = props;

  const classNames = buildClassNames(transitionName);
  const timeout = buildTimeout(
    transitionAppearTimeout,
    transitionEnterTimeout,
    transitionLeaveTimeout
  );

  const items = React.Children.toArray(children).filter(Boolean);

  return (
    <TransitionGroup ref={ref} component={component} {...rest}>
      {items.map((child) => (
        <CSSTransition
          key={child.key}
          classNames={classNames}
          timeout={timeout}
          appear={transitionAppear}
          enter={transitionEnter}
          exit={transitionLeave}
        >
          {child}
        </CSSTransition>
      ))}
    </TransitionGroup>
  );
});

export { CSSTransitionGroup };
export default CSSTransitionGroup;
